"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  transition: all 300ms ease-in-out;\n  height: 2px;\n  width: ", "%;\n  margin-left: ", "%;\n  background-color: #0AC18E;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    height: 1px;\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    display: inline-block;\n    position: relative;\n    list-style: none;\n    padding: 14px 10px;\n    cursor: pointer;\n    font-size: 17px;\n    font-weight: bold;\n    text-align: center;\n    &:hover {\n      background-color: rgba(216, 216, 216, 0.16);\n    }\n    &:active {\n      background-color: rgba(216, 216, 216, 0.5);\n    }\n    &.selected {\n      color: ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    display: grid;\n    align-items: center;\n    justify-self: left;\n    position: relative;\n    width: 100%;\n    flex-basis: 100%;\n    align-self: flex-start;\n    grid-template-columns: repeat(", ", 1fr);\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.Wrapper = styled_components_1["default"].div(_templateObject());
exports.TabsWrapper = styled_components_1["default"].div(_templateObject2(), function (_ref) {
  var count = _ref.count;
  return styled_components_1.css(_templateObject3(), count);
});
exports.Tab = styled_components_1["default"].div(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme;
  return styled_components_1.css(_templateObject5(), theme.palette.text.secondary, theme.palette.text["default"]);
});
exports.BackgroundBar = styled_components_1["default"].div(_templateObject6(), function (_ref3) {
  var theme = _ref3.theme;
  return styled_components_1.css(_templateObject7(), theme.palette.border["default"]);
});
exports.SelectionBar = styled_components_1["default"].div(_templateObject8(), function (_ref4) {
  var _ref4$count = _ref4.count,
      count = _ref4$count === void 0 ? 3 : _ref4$count;
  return 100 / count;
}, function (_ref5) {
  var _ref5$count = _ref5.count,
      count = _ref5$count === void 0 ? 3 : _ref5$count,
      _ref5$selectedTab = _ref5.selectedTab,
      selectedTab = _ref5$selectedTab === void 0 ? 0 : _ref5$selectedTab;
  return 100 / count * selectedTab;
});